import React from 'react';
import {connect} from "react-redux";
import {setSQFTSystemMessage} from "../../../../actions/sqftMenuFunctions";

const ValidationPopupWindow = (props) => {
  const {id, text, position, isHidden} = props;

  return (
    <div id={id}
         className={"validation-popup " + ( isHidden ? "validation-popup--hidden" : "")}
         style={{top: position.top, left: position.left }}
    >
      <div className="validation-popup_header"/>
      <div className="validation-popup_text">
          {text}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  validationMessage: store.sqftMenuState.validationMessage
});

const mapDispatchToProps = {
  setSQFTSystemMessage
};


export default connect(mapStateToProps, mapDispatchToProps)(ValidationPopupWindow);
